import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';

/**
 * BulkMoveModal - Move multiple documents to a target folder
 */
const BulkMoveModal = ({
  isOpen,
  onClose,
  selectedDocsCount,
  folders,
  targetFolderId,
  setTargetFolderId,
  handleBulkMove,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-slate-50 dark:bg-slate-800 border-slate-300 dark:border-slate-600 text-slate-900 dark:text-slate-100">
        <DialogHeader>
          <DialogTitle className="text-slate-900 dark:text-slate-100">Move {selectedDocsCount} Documents</DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div className="space-y-2">
            <Label className="text-slate-700 dark:text-slate-300">Target Folder</Label>
            <Select value={targetFolderId} onValueChange={setTargetFolderId}>
              <SelectTrigger className="bg-slate-100 dark:bg-slate-800 border-slate-400 dark:border-slate-500 text-slate-900 dark:text-slate-100">
                <SelectValue placeholder="Select target folder" />
              </SelectTrigger>
              <SelectContent className="bg-slate-100 dark:bg-slate-800 border-slate-300 dark:border-slate-600">
                {folders.map(folder => (
                  <SelectItem key={folder.id} value={folder.id} className="text-gray-700 hover:bg-slate-200">{folder.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onClose(false)} className="rounded-full bg-slate-100 dark:bg-slate-800 border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 hover:bg-slate-200 hover:text-slate-900 dark:text-slate-100">Cancel</Button>
          <Button onClick={handleBulkMove} className="rounded-full bg-teal-600 hover:bg-teal-700 text-slate-900 dark:text-slate-100">Move Documents</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BulkMoveModal;
